(function() {
	'use strict';
	/* globals SockJS, Stomp */

	angular.module('quantixApp').factory('PortMigrationService',
			PortMigrationService);

	PortMigrationService.$inject = [ '$rootScope', '$window', '$http', '$q' ];

	function PortMigrationService($rootScope, $window, $http, $q) {

		var _getPortfolioMigrationList = function(searchText) {

			var deferred = $q.defer();
			var url = 'api/PortMigrationReport/getPortMigrationReportDetails';

			$http.post(url, searchText).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _portMigartionMovement = function(data) {
			var deferred = $q.defer();
			var url = 'api/PortMigrationReport/portfolioMigartionMovement';
			$http.post(url, data).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		return {
			getPortfolioMigrationList : _getPortfolioMigrationList,
			portMigartionMovement : _portMigartionMovement

		};
	}
})();
